import React from "react";
import { ScrollAnchorHandler } from './Helpers.jsx';

import video from "../home-banner-video-desktop.mp4"
import videoMobile from "../home-banner-video-mobile-1500x748.mp4"

import hover1 from "../images/top-hover-main-1.jpg"
import hover2 from "../images/top-hover-main-2.jpg"
import hover3 from "../images/top-hover-main-3.jpg"
import hover1alt from "../images/top-hover-main-1-alt.jpg"
import hover2alt from "../images/top-hover-main-2-alt.jpg"
import hover3alt from "../images/top-hover-main-3-alt.jpg"
import hover1mobile from "../images/top-hover-main-1-mobile.jpg"
import hover2mobile from "../images/top-hover-main-2-mobile.jpg"
import hover3mobile from "../images/top-hover-main-3-mobile.jpg"
import hover1altmobile from "../images/top-hover-main-1-alt-mobile.jpg"
import hover2altmobile from "../images/top-hover-main-2-alt-mobile.jpg"
import hover3altmobile from "../images/top-hover-main-3-alt-mobile.jpg"

import devicesdesktop from "../images/hov-devices-desktop.jpg"
import devmobilecenter from "../images/hov-devices-mobile-center.jpg"
import devmobile1 from "../images/hov-devices-mobile-1.jpg"
import devmobile2 from "../images/hov-devices-mobile-2.jpg"
import devmobile3 from "../images/hov-devices-mobile-3.jpg"
import devmobile4 from "../images/hov-devices-mobile-4.jpg"
import devmobile5 from "../images/hov-devices-mobile-5.jpg"
import devmobile6 from "../images/hov-devices-mobile-6.jpg"

import AnimateIcon1 from "../icons/animate-icon-1.jsx";
import AnimateIcon2 from "../icons/animate-icon-2.jsx";
import { Link } from 'react-router-dom';

import Form from "./Form.jsx";

function Home() {

  ScrollAnchorHandler()

  document.addEventListener("DOMContentLoaded", function() {
  const desktopVideo = document.getElementById('desktop-video');
  const mobileVideo = document.getElementById('mobile-video');

  function handleScreenSizeChange(mql) {
      if (mql.matches) {
          desktopVideo.style.display = 'block';
          mobileVideo.style.display = 'none';
      } else {
          desktopVideo.style.display = 'none';
          mobileVideo.style.display = 'block';
      }
  }

  const mediaQueryList = window.matchMedia("(min-width: 567px)");

  handleScreenSizeChange(mediaQueryList);

  mediaQueryList.addListener(handleScreenSizeChange);
});

  return (
    <div id="home">
      <video id="desktop-video" autoPlay loop muted playsInline className="video-banner desktop">
        <source src={video} type="video/mp4" />
      </video>
      <video id="mobile-video" autoPlay loop muted playsInline className="video-banner mobile">
        <source src={videoMobile} type="video/mp4" />
      </video>

      <div className="container py-4">
        <div className="row">
          <h2 className="text-center no-margin compatil-bold fw-bold desktop">Explore how chlorhexidine protection aligns with your role</h2>
          <h2 className="text-center no-margin compatil-bold fw-bold mobile">Explore how<br></br> chlorhexidine protection<br></br> aligns with your role</h2>
        </div>
      </div>

      <div className="container max">
        <div className="row home-hov">
          <div className="col-md-4 col-sm-4 tile-hover">
          <Link to="/provider" onClick={() => { window.scroll(0, 0);}}>
              <div className="desktop">
                <img src={hover1} alt="Provider" className="state-1 img-fluid full-height" />
                <img src={hover1alt} alt="Provider" className="state-2 img-fluid full-height" />
              </div>
              <div className="mobile">
                <img src={hover1mobile} alt="Provider" className="state-1 img-fluid full-height" />
                <img src={hover1altmobile} alt="Provider" className="state-2 img-fluid full-height" />
              </div>
          </Link>
          </div>
          <div className="col-md-4 col-sm-4 tile-hover">
            <Link to="/nurse-technician" onClick={() => { window.scroll(0, 0);}}>
              <div className="desktop">
                <img src={hover2} alt="Nurse/Technician" className="state-1 img-fluid full-height" />
                <img src={hover2alt} alt="Provider" className="state-2 img-fluid full-height" />
              </div>
              <div className="mobile">
                <img src={hover2mobile} alt="Provider" className="state-1 img-fluid full-height" />
                <img src={hover2altmobile} alt="Provider" className="state-2 img-fluid full-height" />
              </div>
            </Link>
          </div>
          <div className="col-md-4 col-sm-4 tile-hover">
          <Link to="/supply-chain" onClick={() => { window.scroll(0, 0);}}>
              <div className="desktop">
                <img src={hover3} alt="Supply Chain" className="state-1 img-fluid full-height" />
                <img src={hover3alt} alt="Provider" className="state-2 img-fluid full-height" />
              </div>
              <div className="mobile">
                <img src={hover3mobile} alt="Provider" className="state-1 img-fluid full-height" />
                <img src={hover3altmobile} alt="Provider" className="state-2 img-fluid full-height" />
              </div>
            </ Link>
          </div>
        </div>
      </div>

      <div className="container desktop">
        <div className="row">
          <div className="col-md-12 col-sm-12">
            <img src={devicesdesktop} alt="" className="img-fluid" />
          </div>
        </div>
      </div>

      <div className="container max mobile">
        <div className="row">
          <div className="col-md-12 col-sm-12">
            <img src={devmobilecenter} alt="" className="img-fluid" />
          </div>
          <div className="col-md-12 col-sm-12">
            <img src={devmobile1} alt="" className="img-fluid" />
          </div>
          <div className="col-md-12 col-sm-12">
            <img src={devmobile2} alt="" className="img-fluid" />
          </div>
          <div className="col-md-12 col-sm-12">
            <img src={devmobile3} alt="" className="img-fluid" />
          </div>
          <div className="col-md-12 col-sm-12">
            <img src={devmobile4} alt="" className="img-fluid" />
          </div>
          <div className="col-md-12 col-sm-12">
            <img src={devmobile5} alt="" className="img-fluid" />
          </div>
          <div className="col-md-12 col-sm-12">
            <img src={devmobile6} alt="" className="img-fluid" />
          </div>
        </div>
      </div>

      <p className="open-sans text-center fst-italic mb-4">Products may not be available in all countries. Please contact your local representative.</p>

      <div className="bg-blue pad-m-y">
        <div className="container m-padding py-5" id="hob_hash">
          <div className="row">
            <div className="col-md-1 col-sm-12"></div>
            <div className="col-md-11 col-sm-12">
              <h2 className="compatil-bold fw-bold text-white">New US Bloodstream Infection Reporting Measures Are Coming<sup>1</sup></h2>
              <h4 className="open-sans color-1 mb-4">As your vascular access partner, we are committed to helping you prepare.</h4>
            </div>
          </div>
        </div>

        <div className="container m-padding">
          <div className="row mb-5">
            <div className="col-md-1 col-sm-12"></div>
            {/* col 1 */}
            <div className="col-md-7 col-sm-6">
              <div className="row">
                <div className="col-md-2 col-sm-6 text-center">
                  <div className="icon-container">
                    <AnimateIcon1 />
                  </div>
                </div>
                <div className="col-md-9 col-sm-6">
                  <h4 className="open-sans min text-white mb-4">It is anticipated that the <strong>new measures</strong> will be used to inform and broaden bloodstream infection (BSI) surveillance regardless of organism (eg, MRSA) or association with device (eg, CLABSI). </h4>
                </div>
              </div>
              <div className="row">
                <div className="col-md-2 col-sm-6 text-center icon-pad">
                  <div className="icon-container">
                    <AnimateIcon2 />
                  </div>
                </div>
                <div className="col-md-9 col-sm-6">
                  <h4 className="open-sans min text-white">The <strong>new surveillance measures</strong> are known as hospital&#8209;onset bacteremia (HOB) and fungemia. The measures are expected to launch in the NHSN application for all acute care hospitals already enrolled and participating in an NHSN program to voluntarily report in 2024.</h4>
                </div>
              </div>
            </div>
            {/* col 2 */}
            <div className="col-md-3 col-sm-6 border-left home flex-v">
              <div className="row">
                <h1 className="compatil-bold xxl-text-home text-white"><strong>25<span className="xxl-sup-home">%</span></strong></h1>
                <h4 className="compatil-bold color-1"><strong><span className="no-break">of healthcare&#8209;associated</span> infections events are a CLABSI<sup>2</sup></strong></h4>
              </div>
            </div>
          </div>

          <div className="container py-4 no-pad-m">
            <div className="row mb-5">
              <div className="col-md-1 col-sm-12"></div>
              <div className="col-md-10 col-sm-12 bg-dark-blue py-4 px-5">
                <h3 className="open-sans color-2"><strong>Our promise:</strong></h3>
                <h4 className="open-sans min text-white">With patients at risk and new HOB measures coming, we are committed to sharing the latest information and listening to you along the way.</h4>
              </div>
              <div className="col-md-1 col-sm-12"></div>
            </div>
          </div>
        </div>
      </div>

      <Form />
      {/* references */}
      <div className="references container m-padding pb-5">
        <div className="row pt-5 ref-text open-sans color-3">
          <p>References:
            <ol>
              <li>Department of Health and Human Services Centers for Disease Control and Prevention; National Center for Emerging and Zoonotic Infectious Diseases Division of Healthcare Quality Promotion: Healthcare Infection Control Practices Advisory Committee. CDC. June 8-9, 2023. Accessed January 29, 2024. <a href="https://www.cdc.gov/hicpac/pdf/2023-June-HICPAC-Summary-508.pdf" target="_blank" rel="noopener noreferrer">https://www.cdc.gov/hicpac/pdf/2023-June-HICPAC-Summary-508.pdf</a></li>
              <li>Centers for Disease Control and Prevention. HAI pathogens and antimicrobial resistance report, 2018-2021. CDC. Updated July 28, 2023. Accessed December 22, 2023. <a href="https://www.cdc.gov/nhsn/hai-report/data-tables-adult/table-2.html" target="_blank" rel="noopener noreferrer">https://www.cdc.gov/nhsn/hai-report/data-tables-adult/table-2.html</a></li>
            </ol>
          </p>
          <p className="pb-3">Rx Only</p>
          <p>Contraindications:</p>
          <p>The Arrowg+ard Blue™ and Arrowg+ard Blue Plus™ Catheters are contraindicated for patients with known hypersensitivity to chlorhexidine, silver sulfadiazine and/or sulfa drugs.</p>
          <p>Clinical assessment of the patient must be completed to ensure no contraindications exist. Arrowg+ard Blue Advance™ Catheters are contraindicated in the following areas:</p>
          <p>
            <ul className="no-margin pb-1">
              <li>Patients with known hypersensitivity to chlorhexidine</li>
              <li>In presence of device-related infections</li>
              <li>In presence of previous or current thrombosis in the intended vessel or along the catheterized vessel pathway</li>
            </ul>
          </p>
          <p>No correlation between <i>in vitro/in vivo</i> testing methods and clinical outcomes have currently been ascertained.</p>
          <p className="pb-4">For complete indications, contraindications, warnings, precautions, and adverse reactions, please reference each referenced product's full package insert.</p>
          <p className="sm">Teleflex, the Teleflex logo, Arrow, Arrowg+ard, Arrowg+ard Blue, Arrowg+ard Blue Plus and Arrowg+ard Blue Advance are trademarks of Teleflex Incorporated or its affiliates, in the U.S. and/or other countries. All other trademarks are trademarks of their respective owners. MC-008512</p>
        </div>
      </div>
    </div>
  );
}

export default Home;
